import {
    Builder,
    BuilderProps,
    Config,
    ImmutableTree,
    JsonLogicTree,
    MuiConfig,
    Utils as QbUtils,
    Query
} from '@react-awesome-query-builder/mui'
import '@react-awesome-query-builder/mui/css/styles.css'
import axios from 'axios'
import _ from 'lodash'
import { useEffect, useState } from 'react'

interface PersonalizationRuleQueryBuilderProps {
    rules: string
    alwaysApply: boolean
    builderConfig: any
    setRulesCallBack: (rules: string) => void
}

const PersonalizationRuleQueryBuilder = ({
    rules,
    alwaysApply,
    builderConfig,
    setRulesCallBack
}: PersonalizationRuleQueryBuilderProps) => {
    const jsonRules = JSON.parse(rules)
    const logic: JsonLogicTree | undefined =
        jsonRules && Object.keys(jsonRules).length > 0 ? (jsonRules as JsonLogicTree) : undefined

    const fields =
        builderConfig?.personalizationRuleBuilderConfig &&
        JSON.parse(builderConfig.personalizationRuleBuilderConfig, (key, value) => {
            if (key === 'fieldSettings') {
                if (value?.asyncFetch) {
                    const query = value.asyncFetch.url
                    const mapping = value.asyncFetch.mapping
                    value.asyncFetch = async (search, offset) => {
                        const toSearch = _.isEmpty(search) ? '' : search
                        const response = await axios.get(`${query}${toSearch}`)
                        const values = response.data.map((val) => ({
                            title: val[mapping.title],
                            value: val[mapping.value].toString()
                        }))
                        let hasMore = false
                        return {
                            values,
                            hasMore
                        }
                    }
                }
            }
            return value
        })

    const initialConfig = {
        ...MuiConfig,
        fields: fields
    }

    // Set state
    const [config, setConfig] = useState<Config>(initialConfig)
    const qbLoadedFromJsonLogic = QbUtils.loadFromJsonLogic(logic, config)
    const [tree, setTree] = useState(
        qbLoadedFromJsonLogic ? QbUtils.sanitizeTree(qbLoadedFromJsonLogic, config).fixedTree : null
    )

    // Update state and thus form field "rules"
    useEffect(() => {
        const rules = !!tree && JSON.stringify(QbUtils.jsonLogicFormat(tree, config).logic)
        if (rules) setRulesCallBack(rules)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tree, config])

    // Update tree and config state based on changes made in the querybuilder
    const onChange = (immutableTree: ImmutableTree, config: Config) => {
        setTree(immutableTree)
        setConfig(config)
    }

    return alwaysApply ? null : (
        <Query
            {...config}
            value={
                tree ||
                QbUtils.checkTree(QbUtils.loadTree({ id: QbUtils.uuid(), type: 'group' }), config)
            }
            onChange={onChange}
            renderBuilder={(props: BuilderProps) => (
                <div className="query-builder-container">
                    <div className="query-builder qb-lite">
                        <Builder {...props} />
                    </div>
                </div>
            )}
        />
    )
}

export default PersonalizationRuleQueryBuilder
